import type { Messages } from './en.js';

/**
 * العربية — RTL. المصطلحات متوافقة مع صفحة الهبوط (الخط الزمني، التكرارات…).
 * The provider sets `dir="rtl"` on <html> when this locale is active.
 */
export const ar: Messages = {
  // ── nav ────────────────────────────────────────────────────────────────
  'nav.timeline': 'الخط الزمني',
  'nav.search': 'بحث',
  'nav.duplicates': 'التكرارات',
  'nav.collections': 'المجموعات',
  'nav.import': 'استيراد',
  'nav.trash': 'سلة المهملات',
  'nav.settings': 'الإعدادات',

  // ── common actions ─────────────────────────────────────────────────────
  'common.restore': 'استعادة',
  'common.delete': 'حذف',
  'common.cancel': 'إلغاء',
  'common.save': 'حفظ',
  'common.close': 'إغلاق',
  'common.upgrade': 'ترقية',
  'common.upgradeToPro': 'الترقية إلى Pro',
  'common.search': 'بحث',
  'common.tryAgain': 'حاول مرة أخرى',
  'common.loading': 'جارٍ التحميل…',
  'common.back': 'رجوع',
  'common.skip': 'تخطٍّ',
  'common.verify': 'تحقّق',
  'common.resend': 'إعادة الإرسال',
  'common.free': 'Free',
  'common.pro': 'Pro',
  'common.clearFilters': 'مسح عوامل التصفية',
  'common.addToChrome': 'أضِف إلى Chrome',
  'toast.genericError': 'حدث خطأ ما. حاول مرة أخرى.',

  // ── plural units ───────────────────────────────────────────────────────
  'unit.tabs.one': 'تبويب واحد',
  'unit.tabs.few': '{count} تبويبات',
  'unit.tabs.many': '{count} تبويبًا',
  'unit.tabs.other': '{count} تبويب',
  'unit.sessions.one': 'جلسة واحدة',
  'unit.sessions.few': '{count} جلسات',
  'unit.sessions.many': '{count} جلسة',
  'unit.sessions.other': '{count} جلسة',
  'unit.items.one': 'عنصر واحد',
  'unit.items.few': '{count} عناصر',
  'unit.items.many': '{count} عنصرًا',
  'unit.items.other': '{count} عنصر',
  'unit.entries.one': 'سجل واحد',
  'unit.entries.few': '{count} سجلات',
  'unit.entries.many': '{count} سجلًا',
  'unit.entries.other': '{count} سجل',
  'unit.copies.one': 'نسخة واحدة',
  'unit.copies.few': '{count} نسخ',
  'unit.copies.many': '{count} نسخة',
  'unit.copies.other': '{count} نسخة',
  'unit.browsers.one': 'متصفح واحد',
  'unit.browsers.few': '{count} متصفحات',
  'unit.browsers.many': '{count} متصفحًا',
  'unit.browsers.other': '{count} متصفح',

  // ── app shell ──────────────────────────────────────────────────────────
  'shell.searchPlaceholder': 'ابحث في خزنتك…',
  'shell.saved': 'محفوظ',
  'shell.toggleTheme': 'تبديل المظهر',

  // ── timeline ───────────────────────────────────────────────────────────
  'timeline.empty.title': 'خزنتك فارغة — حتى الآن',
  'timeline.empty.body':
    'اكنس نافذة كاملة بامتداد TabVault، أو أنقذ مقبرة OneTab القديمة. كل شيء يصل إلى هنا، وقابل للبحث.',
  'timeline.empty.import': 'استورد تبويباتك',
  'timeline.empty.importOneTab': 'استيراد من OneTab',
  'timeline.empty.tip': 'نصيحة: ⇧⌘S يكنس النافذة الحالية من الامتداد',
  'timeline.noMatch.title': 'لا توجد جلسات مطابقة لهذه المرشحات',
  'timeline.noMatch.body': 'جرّب نطاق تواريخ أوسع، أو متصفحًا آخر، أو عطّل «بمحتوى فقط».',
  'timeline.loadOlder': 'تحميل الجلسات الأقدم',
  'timeline.toast.sessionDeleted': 'حُذفت الجلسة',
  'timeline.toast.loadFailed': 'تعذّر تحميل هذه الجلسة',
  'timeline.delete.title': 'حذف هذه الجلسة؟',
  'timeline.delete.subtitle': 'سيُزال «{title}» وما فيه من {tabs}. لا يمكن التراجع عن هذا.',
  'timeline.delete.body': 'إن غيّرت رأيك، ما زال بإمكانك استرجاع التبويبات من سجل المتصفح.',
  'timeline.delete.confirm': 'حذف الجلسة',
  'timeline.delete.fallbackTitle': 'هذه الجلسة',
  'timeline.offline.title': 'أنت غير متصل',
  'timeline.offline.body': 'تعمل خزنتك محليًا — وتستأنف المزامنة تلقائيًا عند عودة الاتصال.',
  'timeline.error.title': 'تعذّر تحميل الخط الزمني',
  'timeline.error.body': 'حدث خطأ أثناء الوصول إلى الخزنة. تحقّق من اتصالك وحاول مجددًا.',

  // ── search ─────────────────────────────────────────────────────────────
  'search.mode.text': 'نصي',
  'search.mode.hybrid': 'هجين',
  'search.mode.semantic': 'دلالي',
  'search.placeholder': 'ابحث في خزنتك…',
  'search.clear': 'مسح البحث',
  'search.status.counted': 'نبحث في {count} تبويب',
  'search.status.default': 'نبحث في خزنتك',
  'search.empty.title': 'ابحث في كل ما حفظته',
  'search.empty.body':
    'اعثر على التبويب من عنوانه، أو رابطه، أو الكلمات المكتوبة في الصفحة. الوضع الدلالي يجده من معناه.',
  'search.noMatch.title': 'لا نتائج لـ «{q}»',
  'search.noMatch.body': 'جرّب كلمات أقل أو مختلفة، أو انتقل إلى الوضع الهجين، أو امسح المرشحات.',
  'search.failed.eyebrow': '— فشل البحث',
  'search.failed.body': 'حدث خطأ أثناء الوصول إلى خزنتك.',
  'search.failed.retryHint': 'جرّب مرة أخرى.',
  'search.results': '{count} نتيجة',
  'search.sort.relevance': 'الصلة',
  'search.sort.date': 'التاريخ',
  'search.loadMore': 'تحميل مزيد من النتائج',
  'search.bestMatch': 'أفضل تطابق',
  'search.openedIn': 'فتحت هذا في {browser}',
  'search.facet.browser': 'المتصفح',
  'search.facet.date': 'التاريخ',
  'search.facet.topDomains': 'أبرز النطاقات',
  'search.range.any': 'أي وقت',
  'search.range.24h': '24 ساعة',
  'search.range.7d': '7 أيام',
  'search.range.30d': '30 يومًا',
  'search.range.1y': '12 شهرًا',
  'search.upsell.eyebrow': 'البحث الدلالي · PRO',
  'search.upsell.title': 'البحث الدلالي ميزة Pro',
  'search.upsell.body':
    'اعثر على التبويبات من معناها لا من الكلمات المفتاحية فقط — «تلك المقالة عن خفض أسعار الفائدة» بدل العنوان الحرفي. رقِّ اشتراكك لتبحث في كل ما حفظته يومًا.',
  'search.upsell.seePlans': 'عرض خطط Pro',
  'search.upsell.useText': 'ابحث بالنص بدلًا من ذلك',

  // ── duplicates ─────────────────────────────────────────────────────────
  'dupes.title': 'مركز التكرارات',
  'dupes.summary.duplicates': '{count} تكرارات',
  'dupes.summary.ram': '≈ {ram} من الذاكرة ستتحرر',
  'dupes.closeSelected': 'إغلاق المحدد ({count})',
  'dupes.keepNewest': 'أبقِ الأحدث وأغلق الباقي',
  'dupes.error.title': 'تعذّر تحميل التكرارات',
  'dupes.toast.closed': 'أُغلقت {copies}',
  'dupes.toast.closedBody': 'تبقى النسخة الأحدث مفتوحة — وكل نسخة ما زالت محفوظة في خزنتك.',

  // ── collections ────────────────────────────────────────────────────────
  'collections.title': 'المجموعات',
  'collections.subtitle': 'مرتّبة تلقائيًا بالذكاء الاصطناعي — أعد التسمية أو ادمج متى شئت',
  'collections.new': 'مجموعة جديدة',
  'collections.banner.title': 'المجموعات التلقائية بالذكاء الاصطناعي ميزة Pro.',
  'collections.banner.body': 'ما زال بإمكانك إنشاء المجموعات وتنظيمها يدويًا — مجانًا، للأبد.',
  'collections.empty.title': 'لا مجموعات بعد',
  'collections.empty.body':
    'اجمع التبويبات المتشابهة حسب الموضوع. أنشئ واحدة يدويًا — كما يرتّب Pro خزنتك في مجموعات تلقائيًا.',
  'collections.error.title': 'تعذّر تحميل المجموعات',

  // ── import ─────────────────────────────────────────────────────────────
  'import.title': 'استورد مقابر تبويباتك القديمة',
  'import.drop.title': 'أسقط ملف التصدير هنا',
  'import.drop.body': 'OneTab أو Session Buddy أو HTML للإشارات المرجعية —',
  'import.drop.browse': 'تصفّح الملفات',
  'import.readyEyebrow': 'جاهز للاستيراد',

  // ── settings ───────────────────────────────────────────────────────────
  'settings.title': 'الإعدادات',
  'settings.section.account': 'الحساب والمزامنة',
  'settings.section.browsers': 'المتصفحات المتصلة',
  'settings.section.capture': 'قواعد الالتقاط',
  'settings.section.sharing': 'المشاركة',
  'settings.section.storage': 'التخزين',
  'settings.section.appearance': 'المظهر',
  'settings.section.language': 'اللغة',
  'settings.section.about': 'حول',
  'settings.section.danger': 'منطقة الخطر',
  'settings.account.private': 'خاص وآمن',
  'settings.account.yourAccount': 'حسابك',
  'settings.account.proPlan': 'خطة PRO',
  'settings.account.freePlan': 'خطة FREE',
  'settings.account.managePlan': 'إدارة الخطة',
  'settings.account.seePro': 'تعرّف على Pro',
  'settings.account.privacyNote':
    'صفحاتك المحفوظة تبقى خاصة — أنت وحدك من يراها. نحفظها بأمان بعيدًا عن متناول أي أحد آخر.',
  'settings.account.billing': 'الفوترة والمدفوعات',
  'settings.browsers.syncAuto': 'البقية تتزامن تلقائيًا',
  'settings.browsers.thisBrowser': 'هذا المتصفح',
  'settings.browsers.webApp': 'تطبيق الويب',
  'settings.browsers.activeNow': 'نشط الآن',
  'settings.browsers.installHint':
    'ثبّت الامتداد في متصفحاتك الأخرى — ستظهر هنا وتتزامن تلقائيًا.',
  'settings.capture.onDevice': 'على هذا الجهاز',
  'settings.capture.saveContent': 'حفظ محتوى الصفحة للبحث',
  'settings.capture.saveContentDesc': 'نص فقط — يُخزَّن بخصوصية للبحث في النص الكامل',
  'settings.capture.skipIncognito': 'تجاهل نوافذ التصفح الخفي',
  'settings.capture.neverOn': 'لا تلتقط المحتوى أبدًا على:',
  'settings.capture.addSite': '+ أضف موقعًا',
  'settings.capture.localNote':
    'تعيش هذه القواعد في هذا المتصفح حاليًا — ومزامنتها بين الأجهزة قادمة قريبًا.',
  'settings.sharing.readOnly': 'روابط عامة للقراءة فقط',
  'settings.sharing.collection': 'مجموعة',
  'settings.sharing.sweep': 'كنسة',
  'settings.sharing.selectCollection': 'اختر مجموعة…',
  'settings.sharing.selectSweep': 'اختر كنسة…',
  'settings.sharing.createLink': 'إنشاء رابط',
  'settings.sharing.empty.title': 'لا روابط مشاركة بعد',
  'settings.sharing.empty.body': 'أنشئ رابطًا عامًا لمجموعة أو كنسة لمشاركتها — للقراءة فقط.',
  'settings.sharing.copyLink': 'نسخ الرابط',
  'settings.sharing.revoke': 'إبطال',
  'settings.toast.linkCreated': 'أُنشئ رابط المشاركة',
  'settings.toast.linkCreatedBody': 'يمكن لأي شخص لديه الرابط عرضه — للقراءة فقط.',
  'settings.toast.linkFailed': 'تعذّر إنشاء الرابط',
  'settings.toast.linkFailedBody': 'حاول مرة أخرى بعد لحظات.',
  'settings.toast.linkRevoked': 'أُبطل الرابط',
  'settings.toast.linkRevokedBody': 'هذا الرابط لم يعد يعمل.',
  'settings.toast.revokeFailed': 'تعذّر إبطال الرابط',
  'settings.toast.revokeFailedBody': 'حاول مرة أخرى.',
  'settings.toast.copied': 'تم النسخ',
  'settings.toast.copiedBody': 'رابط المشاركة في حافظتك.',
  'settings.toast.deleteFailed': 'فشل الحذف',
  'settings.toast.deleteFailedBody': 'لم نستطع حذف الحساب. حاول مرة أخرى.',
  'settings.danger.export': 'تصدير كل البيانات',
  'settings.danger.deleteAccount': 'حذف الحساب والبيانات',
  'settings.danger.note': 'صدِّر أولًا — يصبح الحذف نهائيًا بعد 14 يومًا.',
  'settings.storage.saved': '{count} محفوظ',
  'settings.storage.tabs': 'التبويبات',
  'settings.storage.sessions': 'الجلسات',
  'settings.storage.indexed': 'مفهرس',
  'settings.appearance.dark': 'المظهر الداكن',
  'settings.appearance.darkDesc': 'كحلي عميق — المظهر الافتراضي',
  'settings.language.label': 'لغة الواجهة',
  'settings.language.desc': 'تُطبَّق فورًا في كل أنحاء التطبيق.',
  'settings.promo.title': 'احصل على الامتداد',
  'settings.promo.body': 'اكنس نافذة كاملة بنقرة واحدة، مباشرة من شريط الأدوات.',
  'settings.about.webApp': 'تطبيق الويب',
  'settings.about.extension': 'الامتداد',
  'settings.deleteModal.title': 'حذف الحساب والبيانات',
  'settings.deleteModal.subtitle': 'هذا يزيل خزنتك من كل مكان.',
  'settings.deleteModal.body':
    'ستُجدول كل كنسة وصفحة محفوظة ومجموعة للحذف. تبقى قابلة للاسترداد 14 يومًا، ثم تختفي نهائيًا. صدِّر بياناتك أولًا إن كنت قد تحتاجها.',
  'settings.deleteModal.keep': 'الإبقاء على الحساب',
  'settings.deleteModal.confirm': 'حذف كل شيء',
  'settings.planModal.title': 'إدارة خطة Pro',
  'settings.planModal.subtitle': 'يبقى Free سخيًا — وPro يربط كل شيء.',
  'settings.planModal.body':
    'ألغِ متى شئت وستحتفظ بـ Pro حتى نهاية فترة الفوترة. بعدها: يبقى الحفظ المحلي بلا حدود، وتنخفض المزامنة إلى متصفح واحد، ويتوقف بحث الذكاء الاصطناعي والمجموعات مؤقتًا.',
  'settings.planModal.nothingDeleted': 'لا يُحذف أي شيء.',
  'settings.planModal.emailSupport': 'راسل الدعم للإلغاء',
  'settings.planModal.keepPro': 'الاحتفاظ بـ Pro',

  // ── login / verify ─────────────────────────────────────────────────────
  'login.welcome': 'مرحبًا بك في TabVault',
  'login.tagline': 'خزنة واحدة لكل متصفح تستخدمه.',
  'login.emailPlaceholder': 'you@email.com',
  'login.sendLink': 'أرسل الرابط السحري',
  'login.error.tooMany': 'طلبات كثيرة — انتظر دقيقة وحاول مجددًا.',
  'login.error.sendFailed': 'لم نستطع إرسال الرابط الآن. حاول بعد لحظات.',
  'login.reassure': 'صفحاتك المحفوظة تبقى خاصة — أنت وحدك من يفتح خزنتك.',
  'login.checkInbox': 'تفقد بريدك الوارد',
  'login.sentTo': 'أرسلنا رابط تسجيل الدخول إلى',
  'login.expires': 'تنتهي صلاحية الرابط خلال 15 دقيقة',
  'login.nothingThere': 'لم يصلك شيء؟',
  'login.checkSpam': 'تفقد البريد المزعج',
  'login.wrongAddress': '→ عنوان خاطئ؟ ارجع',
  'login.devDivider': 'DEV · الصق الرمز',
  'login.tokenPlaceholder': 'الرمز من وحدة تحكم الـ API',
  'verify.signingIn': 'جارٍ تسجيل دخولك…',
  'verify.hangTight': 'لحظة واحدة، لن يستغرق الأمر سوى ثانية.',
  'verify.expired.title': 'انتهت صلاحية هذا الرابط',
  'verify.expired.body':
    'الروابط السحرية صالحة 15 دقيقة ولاستخدام واحد. اطلب رابطًا جديدًا وستدخل فورًا.',
  'verify.backToSignIn': 'العودة لتسجيل الدخول',

  // ── onboarding ─────────────────────────────────────────────────────────
  'onboarding.hero.title1': 'متصفحك أخيرًا',
  'onboarding.hero.title2': 'صار له ذاكرة.',
  'onboarding.hero.body':
    'اكنس نوافذ كاملة إلى خزنتك، وأغلقها بلا خوف، واعثر على أي صفحة من جديد — مما كان مكتوبًا فيها.',
  'onboarding.getStarted': 'ابدأ',
  'onboarding.hero.micro': 'يستغرق 60 ثانية · لا حاجة لحساب للاستكشاف',
  'onboarding.perm.title': 'لماذا يطلب متصفحك صلاحية الوصول',
  'onboarding.perm.lede': 'الرسالة القادمة تبدو مخيفة. إليك معناها الحقيقي.',
  'onboarding.perm.head': '«قراءة وتغيير كل بياناتك على كل المواقع» — بالترجمة',
  'onboarding.perm.p1.title': 'نقرأ الصفحات فقط لنجعلها قابلة للبحث',
  'onboarding.perm.p1.body': 'لتجد لاحقًا «تلك المقالة عن أسعار الفائدة العقارية».',
  'onboarding.perm.p2.title': 'صفحاتك تبقى خاصة على جهازك',
  'onboarding.perm.p2.body': 'أنت وحدك من يفتح خزنتك — لا نرى ما تحفظه.',
  'onboarding.perm.p3.title': 'يمكن استثناء البنوك والبريد والمواقع الخاصة',
  'onboarding.perm.p3.body': 'قائمة واحدة في الإعدادات — لا يُلتقط المحتوى هناك أبدًا.',
  'onboarding.perm.continue': 'يبدو عادلًا — تابع',
  'onboarding.perm.later': 'اسألني لاحقًا',
  'onboarding.perm.micro': 'يمكنك تغيير هذا في أي وقت من الإعدادات',
  'onboarding.rescue.title': 'أنقذ تبويباتك الآن',
  'onboarding.rescue.lede': 'اختر أحدهما — كلاهما يستغرق أقل من دقيقة، ولا يضيع شيء.',
  'onboarding.rescue.onetab.title': 'استيراد من OneTab',
  'onboarding.rescue.onetab.body':
    'انقل مقبرة OneTab بأكملها بنقرة واحدة — تتحول المجموعات إلى جلسات.',
  'onboarding.rescue.chooseFile': 'اختر ملفًا',
  'onboarding.rescue.onetab.foot': 'أيضًا: SESSION BUDDY · HTML للإشارات المرجعية',
  'onboarding.rescue.ext.title': 'احصل على امتداد المتصفح',
  'onboarding.rescue.ext.body':
    'اكنس نافذة كاملة بنقرة واحدة من شريط الأدوات. وشاهد ذاكرتك وهي تعود.',
  'onboarding.rescue.ext.foot': 'CHROME · EDGE · YANDEX · COMET',
  'onboarding.rescue.openApp': '← افتح تطبيق الويب',

  // ── pricing ────────────────────────────────────────────────────────────
  'pricing.title': 'انتقل إلى Pro عندما تكون جاهزًا',
  'pricing.subtitle': 'يبقى Free سخيًا. وPro يربط كل شيء.',
  'pricing.monthly': 'شهري ${price}',
  'pricing.yearly': 'سنوي ${price}',
  'pricing.forever': 'للأبد',
  'pricing.yourPlan': 'خطتك',
  'pricing.mostLoved': 'الأكثر حبًا',
  'pricing.perMonth': '/شهر',
  'pricing.perMonthYearly': '/شهر · ${total} سنويًا',
  'pricing.free.f1': 'حفظ محلي بلا حدود',
  'pricing.free.f2': 'متصفح واحد متزامن مع السحابة',
  'pricing.free.f3': 'بحث في العنوان والرابط',
  'pricing.free.f4': 'بحث في النص الكامل وبالذكاء الاصطناعي',
  'pricing.free.f5': 'مجموعات الذكاء الاصطناعي',
  'pricing.pro.f1': 'كل المتصفحات وكل الأجهزة متزامنة',
  'pricing.pro.f2': 'نص كامل + بحث دلالي بالذكاء الاصطناعي',
  'pricing.pro.f3': 'مجموعات ذكية ترتّب نفسها بنفسها',
  'pricing.pro.f4': 'سجل إصدارات الصفحات المحفوظة',
  'pricing.pro.f5': 'دعم ذو أولوية',
  'pricing.stayFree': 'البقاء على Free',
  'pricing.youreOnPro': 'أنت على Pro',
  'pricing.signInToUpgrade': 'سجّل الدخول للترقية',
  'pricing.checkoutSoon': 'الدفع سيفتح قريبًا — سنراسلك فور تشغيله.',
  'pricing.checkoutFailed': 'حدث خطأ عند بدء الدفع. حاول مرة أخرى.',
  'pricing.footer': 'إلغاء في أي وقت · صدِّر بياناتك متى شئت · الحفظ المحلي لا يُقفل أبدًا',

  // ── billing / version history ──────────────────────────────────────────
  'billing.title': 'الفوترة والمدفوعات',
  'versions.title': 'سجل الإصدارات',
  'versions.current': 'الحالي',
  'versions.restoreThis': 'استعادة هذا الإصدار',

  // ── trash ──────────────────────────────────────────────────────────────
  'trash.title': 'سلة المهملات',
  'trash.autoPurge': 'تفريغ تلقائي بعد 14 يومًا',
  'trash.itemsLoading': '… عناصر',
  'trash.restoreSelected': 'استعادة المحدد ({count})',
  'trash.restoring': 'جارٍ الاستعادة…',
  'trash.emptyTrash': 'تفريغ السلة',
  'trash.error.title': 'تعذّر تحميل سلة المهملات',
  'trash.emptyState.title': 'سلة المهملات فارغة',
  'trash.emptyState.body':
    'الجلسات والصفحات المحذوفة تنتظر هنا 14 يومًا، ثم تُمحى تلقائيًا.',
  'trash.footNote': 'الحذف من السلة نهائي · صدِّر كل بياناتك من الإعدادات ← منطقة الخطر',
  'trash.purge.title': 'حذف نهائي؟',
  'trash.purge.subtitle': 'سيُزال «{title}» نهائيًا — دون مهلة الـ 14 يومًا للاسترداد.',
  'trash.purge.confirm': 'حذف نهائي',
  'trash.purge.sweepBody': 'هذا يحذف الجلسة وما فيها من {tabs} نهائيًا.',
  'trash.purge.pageBody': 'هذا يحذف الصفحة المحفوظة ومحتواها الملتقط نهائيًا.',
  'trash.emptyConfirm.title': 'تفريغ سلة المهملات؟',
  'trash.emptyConfirm.subtitle': 'يحذف {entries} نهائيًا.',
  'trash.emptyConfirm.body':
    'كل ما في السلة سيختفي للأبد — لا يمكن التراجع عن هذا. يمكنك تصدير بياناتك في أي وقت من الإعدادات ← منطقة الخطر.',
  'trash.toast.restored': 'تمت الاستعادة',
  'trash.toast.restoredBody': '«{title}» عاد إلى خزنتك.',
  'trash.toast.restoredMany': 'استُعيد {entries}',
  'trash.toast.restoreFailed': 'تعذّرت الاستعادة',
  'trash.toast.restoreManyFailed': 'تعذّرت استعادة المحدد',
  'trash.toast.purged': 'حُذف نهائيًا',
  'trash.toast.purgedBody': '«{title}» ذهب بلا رجعة.',
  'trash.toast.purgeFailed': 'تعذّر الحذف',
  'trash.toast.emptied': 'فُرِّغت السلة',
  'trash.toast.emptiedBody': 'حُذف كل ما في السلة نهائيًا.',
  'trash.toast.emptyFailed': 'تعذّر تفريغ السلة',
};
